import type { PlacePreviewFeature, PlaceType } from "./api";

const MAKI_TO_PLACE_TYPE: Record<string, PlaceType> = {
  // Food & Drink
  cafe: "cafe",
  coffee: "cafe",
  bakery: "cafe",
  "ice-cream": "cafe",
  teahouse: "cafe",
  restaurant: "restaurant",
  "fast-food": "restaurant",
  "restaurant-bbq": "restaurant",
  "restaurant-noodle": "restaurant",
  "restaurant-pizza": "restaurant",
  "restaurant-seafood": "restaurant",
  "restaurant-sushi": "restaurant",
  bar: "bar",
  beer: "bar",
  nightclub: "bar",
  // Accommodation
  lodging: "accommodation",
  hotel: "accommodation",
  campsite: "campground",
  shelter: "hut",
  // Shopping & Essentials
  grocery: "grocery-store",
  convenience: "convenience-store",
  pharmacy: "pharmacy",
  // Activities & Outdoors
  hiking: "hiking",
  mountain: "hiking",
  skiing: "ski-resort",
  attraction: "activity",
  "amusement-park": "activity",
  zoo: "activity",
  aquarium: "activity",
  museum: "activity",
  theatre: "activity",
  cinema: "activity",
  castle: "activity",
  stadium: "activity",
  "bowling-alley": "activity",
  bicycle: "bike-shop",
  "bicycle-share": "bike-shop",
  // Wellness & Fitness
  "fitness-centre": "gym",
  swimming: "swimming-pool",
  "hot-spring": "hot-spring",
  // Services & Infrastructure
  library: "library",
  park: "public-park",
  "park-alt1": "public-park",
  "dog-park": "public-park",
  garden: "public-park",
  playground: "public-park",
  parking: "parking",
  "parking-garage": "parking",
  "parking-paid": "parking",
  bus: "public-transport",
  rail: "public-transport",
  "rail-light": "public-transport",
  "rail-metro": "public-transport",
  ferry: "public-transport",
};

const CLASS_TO_PLACE_TYPE: Record<string, PlaceType> = {
  food_and_drink: "restaurant",
  food_and_drink_stores: "grocery-store",
  lodging: "accommodation",
  sport_and_leisure: "activity",
  arts_and_entertainment: "activity",
  park_like: "public-park",
  store_like: "convenience-store",
  historic: "activity",
  landmark: "activity",
};

export function suggestPlaceType(poi: { maki?: string; poiClass?: string }): PlaceType | null {
  if (poi.maki) {
    const fromMaki = MAKI_TO_PLACE_TYPE[poi.maki];
    if (fromMaki) return fromMaki;
  }
  if (poi.poiClass) {
    return CLASS_TO_PLACE_TYPE[poi.poiClass] ?? null;
  }
  return null;
}

/**
 * Creates a synthetic PlaceFeature from Mapbox POI data for preview in the panel.
 * The empty `id` distinguishes it from real places in the database.
 * Type can be null when it can't be detected from the POI.
 */
export function mapPlaceFeatureFromMapboxPoi(poi: {
  name: string;
  coordinates: [number, number];
  suggestedType: PlaceType | null;
  address?: string;
}): PlacePreviewFeature {
  return {
    type: "Feature",
    id: undefined,
    geometry: { type: "Point", coordinates: poi.coordinates },
    properties: {
      id: "",
      status: "unlisted",
      permissions: { canEdit: false, canDelete: false, canPublish: false, canTransfer: false },
      name: poi.name,
      type: poi.suggestedType,
      description: poi.address ?? null,
      images: [],
      links: [],
      email: null,
      phone: null,
      metadata: null,
    },
  };
}
